"use strict";
// ToDo after design update this component will be delete. Please use PostCode for new design instead this
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PublicCode = function (_a) {
    var _b;
    var code = _a.code, _c = _a.right, right = _c === void 0 ? false : _c, className = _a.className;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("p", { className: classnames_1.default(styles_module_scss_1.default.public_code, (_b = {},
            _b[styles_module_scss_1.default.align_right] = right,
            _b[className] = !!className,
            _b)) },
        react_1.default.createElement("span", { className: styles_module_scss_1.default.pc_text }, t('PUBLIC_CODE.CODE')),
        ":",
        ' ',
        react_1.default.createElement("span", { className: styles_module_scss_1.default.pc_val }, code)));
};
exports.default = PublicCode;
